<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-16 14:32:22
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-22 17:22:11
 * @FilePath: \onetab\src\components\ShareBtn.vue
-->
<template>
  <div class="share-btn" @click="handleShare">
    <i class="iconfont icon-onetaba-1"></i>
  </div>
  <ShareModal :visible="visible" @close="visible = false" />
  <SettingModal
    class="setting-modal"
    v-if="showSetting"
    @handleClose="showSetting = false"
    key="setting"
    :selected="settingSelected"
  />
</template>

<script setup>
import { user } from '@/store/user';
import { RaMessage } from '@rafter/pc';
import { ref, onMounted } from 'vue';
import ShareModal from './ShareModal.vue';
const showSetting = ref(false);
import SettingModal from './SettingModal.vue';
const settingSelected = ref({
  name: '登录',
  value: 'login',
});
const visible = ref(false);
const handleShare = () => {
  if (!user.token) {
    return (showSetting.value = true);
  }
  visible.value = true;
};
</script>
<style lang="scss" scoped>
.share-btn {
  display: inline-flex;
  height: 48px;
  min-width: 48px;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(26, 26, 26, 0.08);
  background-blend-mode: luminosity;
  backdrop-filter: blur(60px);
  justify-content: center;
  position: absolute;
  right: 12px;
  z-index: 2;
  cursor: pointer;
  .iconfont {
    font-size: 24px;
    @include font_color('base-bg-color-09');
  }

  &:hover {
    @include background_color('base-bg-color-app-04');
  }
}
</style>
